(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["daniel-free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
  var bars = document.querySelectorAll('[data-daniel-shipping-bar]');
  if (!bars.length) return;

  var cartUrlPattern = /\/cart\/(add|change|update|clear)(\.js)?/;

  function parseConfig(bar) {
    var node = bar.querySelector('[data-daniel-shipping-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function countryFor(bar, config) {
    var country = (bar.dataset.country || '').toUpperCase();
    var language = (bar.dataset.language || '').toLowerCase();
    var currency = (bar.dataset.currency || '').toUpperCase();
    if (config.markets[country]) return country;
    if (language.indexOf('sv') === 0 && config.markets.SE) return 'SE';
    if (language.indexOf('fi') === 0 && config.markets.FI) return 'FI';
    if (language.indexOf('da') === 0 && config.markets.DK) return 'DK';
    if (currency === 'SEK' && config.markets.SE) return 'SE';
    if (currency === 'EUR' && config.markets.FI) return 'FI';
    if (currency === 'DKK' && config.markets.DK) return 'DK';
    return config.defaultCountry || Object.keys(config.markets)[0];
  }

  function formatMoney(cents, currency) {
    var value = Math.max(0, Number(cents) || 0) / 100;
    var rounded = Math.round(value);
    if (currency === 'EUR') {
      return '€' + (Number.isInteger(value) ? String(rounded) : value.toFixed(2).replace('.', ','));
    }
    if (currency === 'SEK' || currency === 'DKK') {
      return String(rounded) + ' kr';
    }
    return String(rounded) + ',-';
  }

  function renderMessage(template, market, amount) {
    return template
      .replace('{goal}', formatMoney(market.goal, market.currency))
      .replace('{remaining}', formatMoney(amount, market.currency));
  }

  function syncSpacer(bar) {
    var spacer = bar.nextElementSibling;
    var root = document.documentElement;
    if (!spacer || !spacer.matches('[data-daniel-shipping-spacer]')) return;
    if (bar.hidden) {
      spacer.style.height = '0px';
      spacer.style.minHeight = '0px';
      root.style.setProperty('--daniel-shipping-bar-height', '0px');
      root.classList.remove('daniel-shipping-bar-visible');
      return;
    }
    var height = Math.ceil(bar.getBoundingClientRect().height);
    spacer.style.height = height + 'px';
    spacer.style.minHeight = height + 'px';
    root.style.setProperty('--daniel-shipping-bar-height', height + 'px');
    root.classList.add('daniel-shipping-bar-visible');
  }

  function updateBar(bar, cart) {
    var config = parseConfig(bar);
    if (!config || !config.markets) return;
    // Danish visitors must never inherit an unconfirmed Norwegian offer.
    if (!config.markets.DK && (bar.dataset.country === 'DK' || (bar.dataset.language || '').indexOf('da') === 0)) {
      bar.hidden = true;
      syncSpacer(bar);
      return;
    }
    var country = countryFor(bar, config);
    var market = config.markets[country] || config.markets[config.defaultCountry];
    if (!market) return;

    var total = Number(cart && cart.total_price) || 0;
    var remaining = Math.max(0, market.goal - total);
    var message = total <= 0 ? market.initial : market.remaining;
    if (remaining <= 0) message = market.success;

    var messageNode = bar.querySelector('[data-daniel-shipping-message]');
    var progressNode = bar.querySelector('[data-daniel-shipping-progress]');
    var closeNode = bar.querySelector('[data-daniel-shipping-close]');
    var renderedMessage = renderMessage(message, market, remaining);
    var progress = Math.min(100, Math.max(0, total / market.goal * 100));
    var hadProgress = typeof bar.dataset.danielShippingProgressValue !== 'undefined';
    var previousProgress = Number(bar.dataset.danielShippingProgressValue || 0);
    bar.dataset.danielShippingExpected = renderedMessage;
    bar.dataset.danielShippingProgressState = progress >= 100 ? 'complete' : progress > 0 ? 'active' : 'empty';
    bar.dataset.danielShippingProgressValue = String(progress);
    if (hadProgress && progress > previousProgress + 0.4) {
      bar.dataset.danielShippingProgressMotion = 'up';
      if (bar.__danielShippingProgressMotionTimer) window.clearTimeout(bar.__danielShippingProgressMotionTimer);
      bar.__danielShippingProgressMotionTimer = window.setTimeout(function () {
        if (bar.dataset.danielShippingProgressMotion === 'up') delete bar.dataset.danielShippingProgressMotion;
      }, 780);
    } else if (progress < previousProgress - 0.4) {
      delete bar.dataset.danielShippingProgressMotion;
    }
    if (messageNode) messageNode.textContent = renderedMessage;
    if (progressNode) progressNode.style.width = progress + '%';
    if (closeNode && market.close) closeNode.setAttribute('aria-label', market.close);
    bar.hidden = false;
    syncSpacer(bar);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('cart');
      return response.json();
    });
  }

  function refresh() {
    fetchCart().then(function (cart) {
      bars.forEach(function (bar) {
        var config = parseConfig(bar);
        if (!config) return;
        var closedKey = 'danielShippingBarClosed:' + config.store + ':' + (bar.dataset.country || config.defaultCountry || '');
        if (sessionStorage.getItem(closedKey) === '1') {
          bar.hidden = true;
          syncSpacer(bar);
          return;
        }
        updateBar(bar, cart);
      });
    }).catch(function () {
      bars.forEach(function (bar) {
        updateBar(bar, { total_price: 0 });
      });
    });
  }

  function renderInitial() {
    bars.forEach(function (bar) {
      var config = parseConfig(bar);
      if (!config) return;
      var closedKey = 'danielShippingBarClosed:' + config.store + ':' + (bar.dataset.country || config.defaultCountry || '');
      if (sessionStorage.getItem(closedKey) === '1') {
        bar.hidden = true;
        return;
      }
      updateBar(bar, { total_price: 0 });
    });
  }

  bars.forEach(function (bar) {
    var config = parseConfig(bar);
    var closeNode = bar.querySelector('[data-daniel-shipping-close]');
    var messageNode = bar.querySelector('[data-daniel-shipping-message]');
    if (messageNode && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        var expected = bar.dataset.danielShippingExpected;
        if (expected && messageNode.textContent !== expected) messageNode.textContent = expected;
      });
      observer.observe(messageNode, { childList: true, characterData: true, subtree: true });
    }
    if (closeNode) {
      closeNode.addEventListener('click', function () {
        var closedKey = 'danielShippingBarClosed:' + ((config && config.store) || bar.dataset.store || 'store') + ':' + (bar.dataset.country || (config && config.defaultCountry) || '');
        sessionStorage.setItem(closedKey, '1');
        bar.hidden = true;
        syncSpacer(bar);
      });
    }
  });

  window.addEventListener('resize', function () {
    bars.forEach(syncSpacer);
  });

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var request = arguments[0];
      var url = typeof request === 'string' ? request : request && request.url;
      var shouldRefresh = url && cartUrlPattern.test(url);
      return originalFetch.apply(this, arguments).then(function (response) {
        if (shouldRefresh) window.setTimeout(refresh, 120);
        return response;
      });
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__danielShippingBarRefresh = url && cartUrlPattern.test(String(url));
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__danielShippingBarRefresh) {
      this.addEventListener('loadend', function () {
        window.setTimeout(refresh, 120);
      });
    }
    return originalSend.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'theme:cart:change', 'product:added', 'ajaxProduct:added'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      window.setTimeout(refresh, 80);
    });
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest('form[action*="/cart"]')) window.setTimeout(refresh, 180);
  });

  window.DanielShippingBar = window.DanielShippingBar || {};
  window.DanielShippingBar.refresh = refresh;
  renderInitial();
  refresh();
}());
  } catch(e) { console.error(e); }
})();

})();
